import { render, staticRenderFns } from "./EventsPage.vue?vue&type=template&id=34cdd2ae"
import script from "./EventsPage.vue?vue&type=script&lang=js"
export * from "./EventsPage.vue?vue&type=script&lang=js"
import style0 from "./EventsPage.vue?vue&type=style&index=0&id=34cdd2ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports